// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

.mat-mdc-dialog-content {
  height: 100%;
}

mat-form-field {
  width: 100%;
}
mat-form-field.new {
  width: 90% !important;
}

.add-new-item {
  margin-left: 25px;
  cursor: pointer;
}

.mat-mdc-dialog-actions[align=end] {
  justify-content: flex-end;
}

.bt-spinner {
  display: inline;
  padding-right: 30px;
}

.inner-bt ::ng-deep .mat-mdc-progress-spinner .mdc-circular-progress__indeterminate-circle-graphic {
  stroke: white;
}

.first-field {
  margin-top: 15px;
}

.fixActionRow {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex-grow: 1;
}

::ng-deep .mat-tab-body-wrapper {
  padding-top: 20px !important;
}

::ng-deep mat-tab-group .mat-mdc-tab-header {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1000;
  background: white;
}
::ng-deep mat-tab-group .mat-tab-body-content {
  display: initial;
}

.in-review {
  min-height: 57px;
}

.in-review-at {
  width: 100%;
}

.in-review-predictor {
  padding-top: 5px;
}
.in-review-predictor mat-label {
  font-size: 11px;
  font-weight: 400;
}
.in-review-predictor .badge {
  background-color: rgba(105, 105, 105, 0.25);
  opacity: 0.5;
}

.warning-msg {
  color: orange;
  font-size: 12px;
  margin-bottom: 5px;
  margin-top: -10px;
}

.space {
  margin-left: 8px;
}

.predictor-label {
  color: #919191;
}

.error {
  color: orange;
  font-size: 10.5px;
}

.unknown-date {
  margin-left: -10px;
}

.box {
  padding: 10px;
  border: 1px solid #d0d0d0;
}

.separator {
  margin-bottom: 20px;
}

.toggle-margin {
  margin-top: 10px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/modules/admin/cards/components/dialogs/movement-dialog/movement-dialog.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAdA;EACE,YAAA;AAiBF;;AAdA;EACE,WAAA;AAiBF;AAhBE;EACE,qBAAA;AAkBJ;;AAfA;EACE,iBAAA;EACA,eAAA;AAkBF;;AAfA;EACE,yBAAA;AAkBF;;AAfA;EACE,eAAA;EACA,mBAAA;AAkBF;;AAdE;EAGE,aAAA;AAeJ;;AAXA;EACE,gBAAA;AAcF;;AAXA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAcF;;AAXA;EACE,YAAA;AAcF;;AAXA;EACE,4BAAA;AAcF;;AATE;EACE,gBAAA;EACA,wBAAA;EACA,MAAA;EACA,aAAA;EACA,iBAAA;AAYJ;AAVE;EACE,gBAAA;AAYJ;;AARA;EACE,gBAAA;AAWF;;AATA;EACE,WAAA;AAYF;;AAVA;EACI,gBAAA;AAaJ;AAZE;EACE,eAAA;EACA,gBAAA;AAcJ;AAZE;EACE,2CAAA;EACA,YAAA;AAcJ;;AAVA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAaF;;AAVA;EACE,gBAAA;AAaF;;AAVA;EACE,cAAA;AAaF;;AAVA;EACE,aAAA;EACA,iBAAA;AAaF;;AAVA;EACE,kBAAA;AAaF;;AAVA;EACE,aAAA;EACA,yBAAA;AAaF;;AAVA;EACE,mBAAA;AAaF;;AAVA;EACE,gBAAA;EACA,mBAAA;AAaF","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@use \"@angular/material\" as mat;\n@import \"../../../../../../../theme/theme.scss\";\n\n.mat-mdc-dialog-content {\n  height: 100%;\n}\n\nmat-form-field {\n  width: 100%;\n  &.new {\n    width: 90% !important;\n  }\n}\n.add-new-item {\n  margin-left: 25px;\n  cursor: pointer;\n}\n\n.mat-mdc-dialog-actions[align=\"end\"] {\n  justify-content: flex-end;\n}\n\n.bt-spinner {\n  display: inline;\n  padding-right: 30px;\n}\n\n.inner-bt {\n  ::ng-deep\n    .mat-mdc-progress-spinner\n    .mdc-circular-progress__indeterminate-circle-graphic {\n    stroke: white;\n  }\n}\n\n.first-field {\n  margin-top: 15px;\n}\n\n.fixActionRow {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.spacer {\n  flex-grow: 1;\n}\n\n::ng-deep .mat-tab-body-wrapper {\n  padding-top: 20px !important;\n}\n\n::ng-deep mat-tab-group {\n  // sticky tab header\n  .mat-mdc-tab-header {\n    position: sticky;\n    position: -webkit-sticky;\n    top: 0;\n    z-index: 1000;\n    background: white;\n  }\n  .mat-tab-body-content {\n    display: initial;\n  }\n}\n\n.in-review {\n  min-height: 57px;\n}\n.in-review-at {\n  width: 100%;\n}\n.in-review-predictor {\n    padding-top:5px;\n  mat-label {\n    font-size: 11px;\n    font-weight: 400;\n  }\n  .badge {\n    background-color: rgb(105 105 105 / 25%);\n    opacity: 0.5;\n  }\n}\n\n.warning-msg {\n  color: orange;\n  font-size: 12px;\n  margin-bottom: 5px;\n  margin-top: -10px;\n}\n\n.space {\n  margin-left: 8px;\n}\n\n.predictor-label {\n  color: #919191;\n}\n\n.error {\n  color: mat.m2-get-color-from-palette($my-app-warn);\n  font-size: 10.5px;\n}\n\n.unknown-date {\n  margin-left: -10px;\n}\n\n.box {\n  padding: 10px;\n  border: 1px solid #d0d0d0;\n}\n\n.separator {\n  margin-bottom: 20px;\n}\n\n.toggle-margin {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
